import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchExternalClientDetails, checkIsWBSEValid } from "../../../redux/fui/index";
import { checkRootExisted } from "../../../redux/fui";
import {
    StyledTooltip, StyledRadioGroup,
    TopRadioWrapper,
    StyledFormControl,
    ConfigurationFormLabel,
} from "../FuiStyles";
import { longTextEndDate, rootExistedHint, rootWrongFormatHint } from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent, DateTextFieldCommonComponentv2 } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import { RITMField, OpportunityIDField } from "./IndividualFormFields";
import { checkServiceNowTicket, checkRITM, checkOpportunityID, checkWBSECode, checkPOCname, checkEmailFormat, createMaxDate } from "./CommonFunctions";
import GeneralForm from "./GeneralForm";
import * as fuiRedux from "../../../redux/fui/index";
import { Grid, FormControlLabel, Radio, DialogActions, FormLabel, Checkbox, FormGroup } from "@material-ui/core";
import priceConfig from "./pricetotierMapping";
import { CommonDialog, CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";
import ValidationDialog from './ValidationDialog';
import useFormValidationWithBorders from './useFormValidationWithBorders';

/**
 * Turing Form
 * @author shilpa.adikeshava
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */

const GenWizardAgent = ({
    values, // the value would be changed by user's input
    updateGAForm, //the function to update DPForm values which is from redux
    createdBy, // user's EID
    checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
    isRootExist, // the value that show whether DomainContextRoot exist or not from redux
    setIsAllValid, // the function to check whether all validations are satisfieds
    selectedEnvironment,
    minDate,
    maxDate,
    isServiceEndDateInvalid,
    getSelectedEnvironment,
    getServiceEndDate,
    getNotesValue,
    notesValidations,
    configurationType,
    classes,
    history,
    email,
    idToken,
    isExternalClientLoading,
    externalClientData,
    externalClientError,
    fetchExternalClientDetails,
    isLoading,
    formClickSubmit,
    checkIsWBSEValid,
    isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {

    // open the dialog when user choose Yes in GDPR
    const config = configurationType === "quick";
    //check whether RITM and OpportunityID are valid
    const [isServiceNowTicketValid, setIsServiceNowTicketValid] = useState(true);
    const [serviceNowAPIValid, setServiceNowAPIValid] = useState(null);
    const [isRITMValid, setIsRITMValid] = useState(true);
    const [ritmAPIValid, setRitmAPIValid] = useState(null);
    const [isOpportunityIDValid, setIsOpportunityIDValid] = useState(true);
    const [opportunityAPIValid, setOpportunityAPIValid] = useState(null);
    const [ttpword, setTtpword] = useState({
        'ADO': false,
        'JIRA': false,
        'CONFLUENCE': false,
        'SMTP': false,
        'GCP': false,
        'S3': false,
        'BRArn': false,
        'BRKey': false,
    });
    const [usePAT, setUsePAT] = useState({
        'ADO': false,
        'JIRA': false,
        'CONFLUENCE': false
    });
    // check whether WBSECode and MonthlyTicketVolume are valid
    const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
    const [isProjectNameValid, setIsProjectNameValid] = useState(true);

    const [isDialogFlowDevToken, setIsDialogFlowDevToken] = useState(false);

    const [isDialogFlowClientToken, setIsDialogFlowClientToken] = useState(false);
    //   const [isUsersFieldValid, setUsersField] = useState(false);
    const isGDPR = values.GDPR === "yes";
    const isOpenAI = values.OpenAI === "True";
    // const isMultisource = values.EnableMultisource == true; 
    const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";
    const isDialogFlow = values.DialogFlow === "enabled";
    const isDedicated = values.InstanceType === history.location.state.InstanceType;
    //   const isPaymentRate = values.PaymentRate === "payasyougo";
    const [isNoteVisible, setNoteVisible] = useState(true);

    const instanceType = "Container";
    const Tier = instanceType && instanceType == "Container" ? values.Tier === '' ? 'gold' : values.Tier : values.Tier

    const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
    const [domainContextRoot, setDomainContextRoot] = useState("[__]");
    const [regionCode, setRegionCode] = useState("[__]");
    const [errorADGroup, setErrorADGroup] = useState(false);
    const [errorSADGroup, setErrorSADGroup] = useState(false);
    //check if Admin Distribution Group & Super Admin Distribution Group same
    const [isADSADUnique, setIsADSADUnique] = useState(false);
    const [customURL, setCustomURL] = useState("https://[__].mywizard-aiops.accenture.com/[__]");
    const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
    const [env, setEnv] = useState("");
    const [isPocvalid, setPocvalid] = useState(true);
    const [isPlanInputValid, setIsPlanInputValid] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState([]);
    const [isChecked, setIsChecked] = useState(true);
    const coreVersion = history.location.state.AppCoreVersion;

    //sap agents
    const sapAgent = ["SAPAssessmentAgent", "SAPDeploymentAgent", "SAPAgenticSuite"];
    // AdobeAgent
    const adobeAgent = ["Adobe-Automation-Agent", "Adobe Migration Agent", "Adobe Testing Agent"];
    //disabled agents
    const disabledAgents = ["SAPDeploymentAgent", "SAPAgenticSuite"]
    // Use enhanced validation hook with red borders and dialog management
    const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(values, isWBSEValid, selectedEnvironment);

    const handleContractAvailabilityChange = (event) => {
        const value = event.target.value;
        setIsChecked(value === "yes");
        // updateGAForm("IsContractIdAvailable", value);
        if (value === "no") {
            updateGAForm("IsContractIdAvailable", "no")
            updateGAForm("SAPContractID", "0000000000")
            updateGAForm("EndToEndUId", "");
            updateGAForm("ContractAvailabilityDate", createMaxDate(14));
            setSapContractCodeLength(10)
            setPocvalid(false);
        } else {
            setPocvalid(true);
            updateGAForm("SAPContractID", "")
            updateGAForm("ClientName", "")
            updateGAForm("EndToEndUId", "")
            setSapContractCodeLength(0)
        }
    };

    useEffect(() => {
        if (config) {
            setDomainContextRoot("[__]");
            setRegionCode("[__]");
        }
        updateGAForm("GAVersion", history.location.state.GAVersion)
    }, [config]);
    if (config) {
        // updateGAForm("ClientName", "")
        updateGAForm("EndToEndUId", "")
        updateGAForm("Company", "")
        updateGAForm("AvanadeCountry", "")
        updateGAForm("AccentureCountry", "")
        updateGAForm("InstanceType", "Container")
        updateGAForm("Tier", Tier)
        updateGAForm("ContractAvailabilityDate", "")
        updateGAForm("DeploymentPhase", "Not applicable")
        // updateGAForm("CAMPortalEnvironment", process.env.REACT_APP_CAMENVPORTAL)
    }

    if (!config) {
        if (externalClientData.length > 0) {
            updateGAForm("ClientName", externalClientData[0])
            updateGAForm("EndToEndUId", externalClientData[1])
            updateGAForm("InstanceType", "Container")
            updateGAForm("Tier", Tier)
            if (externalClientData[2] !== undefined)
                updateGAForm("Company", externalClientData[2])
            if (externalClientData[3] !== undefined)
                updateGAForm("AvanadeCountry", externalClientData[3])
            if (externalClientData[4] !== undefined)
                updateGAForm("AccentureCountry", externalClientData[4])
            if (isChecked && externalClientData[5] !== undefined) {
                if (values.GDPR === 'no')
                    updateGAForm("GDPR", externalClientData[5] ? "yes" : "no")
            }
            updateGAForm("ContractAvailabilityDate", "")
            updateGAForm("IsContractIdAvailable", "yes")
            // updateGAForm("CAMPortalEnvironment", process.env.REACT_APP_CAMENVPORTAL)
        } else {
            updateGAForm("InstanceType", "Container")
            updateGAForm("Tier", Tier)
            // updateGAForm("CAMPortalEnvironment", process.env.REACT_APP_CAMENVPORTAL)
        }
    }

    // Since we're now validating only on final submit, always allow the form to be "valid"
    // for navigation purposes. Final validation happens in validateInputFields('submit')
    setIsAllValid(true);

    // user can only input lower case letter and numbers in DomainContextRoot
    const handleChangeRoot = (event, fieldName) => {
        const re = /^[a-z0-9]*$/;
        const value = event.target.value;
        re.test(value) && updateGAForm(fieldName, value);
        setDomainContextRoot(value)
    };
    const handleChangeRootSuggestions = (event, value, fieldName) => {
        const re = /^[a-z0-9]*$/;
        // const value = event.target.value;
        re.test(value) && updateGAForm(fieldName, value);
        setDomainContextRoot(value)
    };

    const clearPATandPassword = (toolName) => {
        const GenTool = values.Genwizard_Tool;
        if (toolName === 'ADO')
            GenTool[toolName]['Username'] = "";
        GenTool[toolName]['PAT'] = "";
        GenTool[toolName]['Password'] = "";
        updateGAForm('Genwizard_Tool', GenTool);
    }

    // get user's input
    const handleChange = (event, fieldName) => {
        if (fieldName === "TentativeServiceEndDate" || fieldName === "ContractAvailabilityDate") {
            updateGAForm(fieldName, event);
            getServiceEndDate(event);
        } else if (fieldName === "TeamName") {
            if (event !== undefined || event !== null) {
                updateGAForm(fieldName, event);
                setIsTeamNameSelected(true);
                if (values.TeamName !== "Others") {
                    updateGAForm("TeamNameOthers", "")
                }
            } else {
                setIsTeamNameSelected(false);
            }
        } else {
            const { value } = event.target;
            event.preventDefault();
            updateGAForm(fieldName, value);
            if (fieldName === "Environment") {
                setEnv(value); // Sync the local env state with the selected value
                getSelectedEnvironment(value);
            }
            if (fieldName === "WBSEcode") {
                const isWBSEFormatValid = checkWBSECode(value);
                if (isWBSEFormatValid) {
                    checkIsWBSEValid(value)
                }
            }
            if (fieldName === "Pocdetails") {
                setPocvalid(checkPOCname(value));
            }
            if (fieldName === "ProjectName") {
                if (value.length > 32 || value.length < 3) {
                    setIsProjectNameValid(false)
                } else {
                    setIsProjectNameValid(true)
                }
            }
            if (fieldName === "RITM") {
                setIsServiceNowTicketValid(checkServiceNowTicket(value, isChecked, config));
            }
            if (fieldName === "DialogFlowDevToken") {
                if (value.length > 0) {
                    setIsDialogFlowDevToken(true);
                } else {
                    setIsDialogFlowDevToken(false);
                }
            }

            if (fieldName === "DialogFlowClientToken") {
                if (value.length > 0) {
                    setIsDialogFlowClientToken(true);
                } else {
                    setIsDialogFlowClientToken(false);
                }
            }

            if (fieldName === "TentativeServiceEndDate") {
                getServiceEndDate(value);
            }

            if (fieldName === "AdminDistributionGroup") {
                if (value == values.SuperAdminDistributionGroup) {
                    setIsADSADUnique(true)
                } else {
                    setIsADSADUnique(false)
                }
                if (value.includes(",") || value.includes(";") || value.includes(" ") || value.includes("@")) {
                    setErrorADGroup(true)
                } else {
                    setErrorADGroup(false)
                }
            }
            if (fieldName === "SuperAdminDistributionGroup") {
                if (value == values.AdminDistributionGroup) {
                    setIsADSADUnique(true)
                } else {
                    setIsADSADUnique(false)
                }
                if (value.includes(",") || value.includes(";") || value.includes(" ") || value.includes("@")) {
                    setErrorSADGroup(true)
                } else {
                    setErrorSADGroup(false)
                }
            }
            if (fieldName === "RequestNotes") {
                if (value.length > 0 && value.length < 247) {
                    getNotesValue({ emptyString: false, maxLength: false });
                } else if (value.length === 0) {
                    getNotesValue({ emptyString: true, maxLength: false });
                } else if (value.length > 246) {
                    getNotesValue({ emptyString: false, maxLength: true });
                }
            }
            if (fieldName === "SAPContractID") {
                let sapLength = value.length
                setSapContractCodeLength(sapLength)
                if (sapLength == 10) {
                    fetchExternalClientDetails(value)
                }
            }
            if (fieldName === "Genwizard_Core") {
                let appcore = values.Genwizard_Core;
                // const pair = ['CUI', 'IAM'];
                const appName = event.target.name;
                if (appcore.includes(appName))
                    appcore = appcore.filter(item => item !== appName);
                else
                    appcore.push(appName)

                if (!(values.Genwizard_Agent_Module.length === 2 && values.Genwizard_Agent_Module.every(item => ['Config-Agent', 'Contact-Center-Agent'].includes(item)))) {
                    if (appcore.includes('AD')) {
                        ['KM', 'CUI'].map(core => {
                            if (!appcore.includes(core))
                                appcore.push(core)
                        })
                    }
                }
                //for CUI and KM
                if (['CUI', 'KM'].includes(event.target.name) && event.target.checked === false) {
                    if (values.Genwizard_Steward_Option === "Knowledge Transition + Agent") {
                        appcore = values.Genwizard_Core;
                    }
                }
                //for Steward logic
                if (event.target.checked === true && event.target.name === 'UTKM') {
                    updateGAForm("Genwizard_Steward_Option", "Knowledge Transition + Agent");
                    if (!appcore.includes('AD')) {
                        ['CUI', 'KM', 'UTKM'].map(core => {
                            if (!appcore.includes(core))
                                appcore.push(core)
                        })
                    } else {
                        appcore.push('UTKM');
                    }
                    let agent = [...values.Genwizard_Agent_Module];
                    if (!agent.includes('Config-Agent')) {
                        updateGAForm("Genwizard_Agent_Module", ['Config-Agent']);
                    }
                } else {
                    if (event.target.name === 'UTKM' && event.target.checked === false) {
                        updateGAForm("Genwizard_Steward_Option", "");
                        if (!appcore.includes('AD')) {
                            appcore = [];
                            let agent = [...values.Genwizard_Agent_Module];
                            agent = agent.filter(item => item !== 'Config-Agent');
                            updateGAForm("Genwizard_Agent_Module", agent);
                        }
                    }
                }
                //for AD logic
                if (['AD'].includes(event.target.name) && event.target.checked === false && event.target.name === 'AD') {
                    if (!appcore.includes('AD')) {
                        if (values.Genwizard_Steward_Option === "Knowledge Transition + IM" || values.Genwizard_Steward_Option === "") {
                            updateGAForm("Genwizard_Agent_Module", []);
                            appcore = []
                        } else {
                            updateGAForm("Genwizard_Agent_Module", ['Config-Agent']);
                        }
                    }
                } else {
                    if (['AD'].includes(event.target.name)) {
                        let agent = [...values.Genwizard_Agent_Module];
                        if (!agent.includes('Config-Agent')) {
                            updateGAForm("Genwizard_Agent_Module", ['Config-Agent']);
                        }
                    }
                }
                updateGAForm(fieldName, appcore);
            }
            // steward select option
            if (fieldName === 'Genwizard_Steward_Option') {
                let appcore = values.Genwizard_Core;
                if (value === "Knowledge Transition + Agent") {
                    if (!appcore.includes('CUI'))
                        appcore.push('CUI')
                    if (!appcore.includes('KM'))
                        appcore.push('KM')
                    //add to core 
                    updateGAForm("Genwizard_Core", appcore);
                    //add to ad agents
                    updateGAForm("Genwizard_Agent_Module", ['Config-Agent']);
                }
                if (value === "Knowledge Transition + IM") {
                    if (!values.Genwizard_Core.includes('AD')) {
                        let agent = [...values.Genwizard_Agent_Module];
                        agent = agent.filter(item => item !== 'Config-Agent');
                        updateGAForm("Genwizard_Agent_Module", agent);
                        appcore = appcore.filter(item => !['CUI', 'KM'].includes(item));
                        //update core 
                        updateGAForm("Genwizard_Core", appcore);
                    }
                }
            }
            //ad agents select option
            if (fieldName === 'Genwizard_Agent_Module') {
                let agent = [...values.Genwizard_Agent_Module];
                // let appcore = values.Genwizard_Core;
                if (event.target.name === 'Config-Agent') {
                    if (event.target.checked === false) {
                        agent = agent.filter(item => item !== 'Config-Agent');
                        updateGAForm("Genwizard_Core", []);
                    } else {
                        agent.push('Config-Agent')
                        updateGAForm("Genwizard_Core", ['AD', 'CUI', 'KM']);
                    }
                    updateGAForm(fieldName, agent);
                } else {
                    if (agent.includes('CIA')) {
                        updateGAForm(fieldName, [...value, 'CIA']);
                    } else {
                        // if (values.Genwizard_Core.some(v => ['AD', 'UTKM'].includes(v))) {
                        if (values.Genwizard_Core.some(v => ['AD'].includes(v))) {
                            if (!value.includes('Config-Agent')) {
                                value.push('Config-Agent');
                            }
                        }
                        updateGAForm(fieldName, [...value]);
                    }
                    if (['Contact-Center-Agent', 'Industry-Rag-Agent', 'Adobe-Automation-Agent', 'Adobe Migration Agent', 'Adobe Testing Agent'].some(item => value.includes(item))) {
                        updateGAForm("ChatGPT", "gpt-5.5-GS,gpt-5.1-GS");
                    } else {
                        updateGAForm("ChatGPT", "gpt-5.1-GS");
                    }
                }
            }
            if (fieldName === "Genwizard_Agent_Tool") {
                let tool = [...values.Genwizard_Agent_Tool];
                const GenTool = values.Genwizard_Tool;
                if (event.target.checked) {
                    if (!tool.includes(event.target.name))
                        tool.push(event.target.name);
                    if (event.target.name === 'ADO') {
                        GenTool[event.target.name] = {
                            'ProjectKey': '',
                            'Endpoint': '',
                            'Username': '',
                            'Password': '',
                            'PAT': '',
                        }
                    } else if (event.target.name === 'FIGMA') {
                        GenTool[event.target.name] = {
                            'Endpoint': '',
                            'PAT': '',
                        }
                    } else {
                        GenTool[event.target.name] = {
                            'ProjectKey': '',
                            'Endpoint': '',
                            'Username': '',
                            'Password': '',
                            'PAT': ''
                        }
                    }
                    updateGAForm("Genwizard_Tool", GenTool)
                } else {
                    tool = tool.filter(item => item !== event.target.name);
                    delete GenTool[event.target.name]
                    updateGAForm("Genwizard_Tool", GenTool)
                }
                updateGAForm(fieldName, [...tool]);
            }

            if (fieldName === 'Genwizard_Tool') {
                const GenTool = values.Genwizard_Tool;
                const toolName = event.target.id.split('_')
                GenTool[toolName[0]][toolName[1]] = value
                updateGAForm(fieldName, GenTool);
            }

            if (fieldName === 'UseS3Bucket') {
                const CAASConfig = values.CCAASConfig;
                const toolName = event.target.id;
                if (value === "No") {
                    CAASConfig['S3Bucket'] = "";
                    CAASConfig['S3AccessId'] = "";
                    CAASConfig['S3AccessKey'] = "";
                    updateGAForm('CAASConfig', CAASConfig);
                }
            }
            if (fieldName === 'UseSMTPConfig') {
                const CAASConfig = values.CCAASConfig;
                //const toolName = event.target.id;
                if (value === "No") {
                    CAASConfig['SMTPUsername'] = "";
                    CAASConfig['SMTPPassword'] = "";
                    CAASConfig['SMTPHostname'] = "";
                    CAASConfig['SMTPPort'] = "";
                    CAASConfig['SMTPSender'] = "";
                    updateGAForm('CAASConfig', CAASConfig);
                }
            }
            if (fieldName === 'CCAASConfig') {
                const CAASConfig = values.CCAASConfig;
                const toolName = event.target.id;
                CAASConfig[toolName] = value
                updateGAForm(fieldName, CAASConfig);
            }
            if (fieldName === 'BRModelNames') {
                updateGAForm(fieldName, value);
            }
            if (fieldName === 'SAPAgentLLM') {
                updateGAForm(fieldName, value);
                let llmConfig = {}
                if (value === "AZURE") {
                    llmConfig = {
                        "Provider": "AZURE",
                        "ClaudeModel": "claude-sonnet-4-5",
                    }

                    updateGAForm("modelname", "claude-sonnet-4-5")
                }
                if (value === "AWS") {
                    llmConfig = {
                        "Provider": "AWS",
                        "Endpoint": "",
                        "Region": "",
                        "Arn": "",
                        "AccessId": "",
                        "AccessKey": "",
                        "DeploymentName": "",
                        "DeploymentModelId": "",
                        "Model": ""
                    }
                }
                updateGAForm("SAPAgentLLMConfig", llmConfig);
            }
            if (fieldName === 'SAPAgentLLMConfig') {
                const llmConfig = { ...values.SAPAgentLLMConfig }
                const llmObjKey = event.target.name.replace('BR_', '');
                llmConfig[llmObjKey] = value;

                if (llmConfig['Model'] && llmConfig['Region']) {
                    const deploymentID = llmConfig['Region'].split('-')[0] + "." + llmConfig['Model'];
                    llmConfig['DeploymentName'] = deploymentID;
                    llmConfig['DeploymentModelId'] = deploymentID;
                }

                if (llmObjKey === "ClaudeModel") {
                    updateGAForm("modelname", value)
                }

                updateGAForm("SAPAgentLLMConfig", llmConfig);
            }

            if (fieldName === "GDPR" && value === "yes") {
                updateGAForm("DeploymentRegion", "");
            }
            if (fieldName === "DeploymentRegion") {
                if (value == "sydney") {
                    setRegionCode("dhuat")
                } else if (value == "virginia") {
                    setRegionCode("dh1uat")
                } else if (value == "frankfurt") {
                    setRegionCode("dh2uat")
                } else if (value == "singapore") {
                    setRegionCode("dh3uat")
                } else if (value == "tokyo") {
                    setRegionCode("dh4uat")
                } else if (value == "ireland") {
                    setRegionCode("dh5uat")
                } else if (value == "london") {
                    setRegionCode("dh6uat")
                } else {
                    setRegionCode("[__]")
                }
            }
            if (fieldName === "DataClassification") {
                if (value === "Client-Production" || value === "Internal-Production") {
                    setEnv("Production")
                } else if (value === "Client-NonProduction") {
                    setEnv("Test")
                } else if (value === "AppTeam-Development") {
                    setEnv("Dev")
                    updateGAForm("Tier", "")
                } else if (value === "AppTeam-Testing") {
                    setEnv("Test")
                    updateGAForm("Tier", "")
                } else {
                    setEnv("")
                    updateGAForm("Tier", "")
                }
            }
        }
    };
    updateGAForm("ConfigurationType", configurationType);
    getSelectedEnvironment(env);
    updateGAForm("Environment", env);
    // it would check whether the root has existed from DB once user stop typing longer than 0.3s
    const debouncedValue = useDebounce(domainContextRoot, 300);
    useEffect(() => {
        debouncedValue && checkDomainAvaliable(debouncedValue);
    }, [debouncedValue]);


    //form validation
    const validateInputFields = (step) => {
        // If not final submit, allow navigation (no validation)
        if (step !== 'submit') {
            return true;
        }

        let ispass = true;
        const missingFields = [];

        // Final submit validation - validate ALL fields across all steps
        const allFieldsRequired = [
            // Step 0 fields
            'ProjectName',
            'WBSEcode',
            'SecondaryPOC',
            'DataClassification',
            'TeamName',
            'RequestNotes',
            // Step 1 fields
            'DeploymentRegion',
            'DomainContextRoot',
            'Environment',
            // Step 2 fields
            'AdminDistributionGroup',
            'TentativeServiceEndDate'
        ];

        // Add conditional required fields
        if (!config) {
            if (isChecked)
                allFieldsRequired.push('SAPContractID');
            else {
                allFieldsRequired.push('Pocdetails', 'ClientName');
                if (values.Genwizard_Core.includes('AM')) {
                    allFieldsRequired.push('OpportunityID');
                }
            }

            // RITM is always mandatory, OpportunityID is optional
            allFieldsRequired.push('RITM');
            // Add DeploymentPhase for full configuration
            allFieldsRequired.push('DeploymentPhase');
        } else {
            // For quick config, only RITM is required remove by ernesto for testing
            allFieldsRequired.push('RITM');
        }

        if (isOpenAI) {
            allFieldsRequired.push(
                'ChatGPT',
                'OpenAITextEmbeddingsModel'
            );
        }

        if (isDialogFlow) {
            allFieldsRequired.push('DialogFlowDevToken', 'DialogFlowClientToken');
        }

        if (values.Genwizard_Agent_Tool.includes('ADO')) {
            allFieldsRequired.push('ADO_ProjectKey', 'ADO_Endpoint', 'ADO_Username', 'ADO_Password', 'ADO_PAT')
        }
        if (values.Genwizard_Agent_Tool.includes('JIRA')) {
            allFieldsRequired.push('JIRA_ProjectKey', 'JIRA_Endpoint', 'JIRA_Username', 'JIRA_Password', 'JIRA_PAT')
        }
        if (values.Genwizard_Agent_Tool.includes('CONFLUENCE')) {
            allFieldsRequired.push('CONFLUENCE_ProjectKey', 'CONFLUENCE_Endpoint', 'CONFLUENCE_Username', 'CONFLUENCE_Password', 'CONFLUENCE_PAT')
        }
        if (values.Genwizard_Agent_Tool.includes('FIGMA')) {
            allFieldsRequired.push('FIGMA_Endpoint', 'FIGMA_PAT')
        }
        if (values.Genwizard_Agent_Module.includes('Contact-Center-Agent')) {
            allFieldsRequired.push(
                'GCPEndPoint', 'GCPAccessKey'
            )
            if (values.UseS3Bucket === "Yes") {
                allFieldsRequired.push(
                    'S3Bucket', 'S3AccessId', 'S3AccessKey'
                )
            }
            if (values.UseSMTPConfig === "Yes") {
                allFieldsRequired.push(
                    'SMTPUsername', 'SMTPPassword', 'SMTPHostname', 'SMTPPort', 'SMTPSender'
                )
            }
        }

        // Validate Genwizard Core selection
        const coreWrapper = document.getElementById('Genwizard_Core_wrapper');
        if (!values.Genwizard_Core || values.Genwizard_Core.length === 0) {
            if (coreWrapper) {
                coreWrapper.style.outline = "1px solid #E20000";
                coreWrapper.style.outlineOffset = "-1px";
                coreWrapper.style.borderRadius = "4px";
            }
            missingFields.push('Genwizard Core selection');
            ispass = false;
        } else {
            if (coreWrapper) coreWrapper.style.outline = "";
        }

        // Validate Agent selection when AD is selected
        const agentWrapper = document.getElementById('Genwizard_agent_wrapper');
        if (
            values.Genwizard_Core &&
            values.Genwizard_Core.includes('AD') &&
            (!values.Genwizard_Agent_Module.filter(item => item !== 'Config-Agent') || values.Genwizard_Agent_Module.filter(item => item !== 'Config-Agent').length === 0)
        ) {
            if (agentWrapper) {
                agentWrapper.style.outline = "1px solid #E20000";
                agentWrapper.style.outlineOffset = "-1px";
                agentWrapper.style.borderRadius = "4px";
            }
            missingFields.push('Agent Module selection (required when AD is selected)');
            ispass = false;
        } else {
            if (agentWrapper) agentWrapper.style.outline = "";
        }

        // if (values.Genwizard_Core.includes('AM')) {
        //     if (values.BRModelNames.length === 0) {
        //         allFieldsRequired.push('BRModelNames');
        //     }
        // }

        if (values.Genwizard_Agent_Module.includes('SAPAgenticSuite') || values.Genwizard_Agent_Module.includes('SAPAssessmentAgent')) {
            if (values.SAPAgentLLM === 'AWS') {
                allFieldsRequired.push(
                    'Bedrock Endpoint', 'Bedrock AccessId', 'Bedrock AccessKey', 'Bedrock Arn', 'Bedrock Region', 'Bedrock Model'
                )
            }
        }

        //remove for now
        // if (values.Genwizard_Agent_Module.includes('CIA') && values.modelname === "") {
        //     missingFields.push('Model Name is required');
        // }
        // if (values.Genwizard_Core.includes('AM')) {
        //     missingFields.push('RITM');
        // }

        // Check for missing fields (basic empty validation - red borders handled by hook)
        for (const fieldname of allFieldsRequired) {
            if (fieldname === "WBSEcode") {
                // WBSE validation: empty OR API validation failed
                if (!values[fieldname] || values[fieldname] === "" || !isWBSEValid) {
                    missingFields.push(fieldname);
                    ispass = false;
                }
            } else if (fieldname === "RITM") {
                if (!values.RITM || values.RITM === "" || values.RITM === null) {
                    missingFields.push(fieldname);
                    ispass = false;
                } else if (ritmAPIValid === false) {
                    missingFields.push(`${fieldname} (not found in records)`);
                    ispass = false;
                } else if (!isRITMValid) {
                    missingFields.push(`${fieldname} (invalid format)`);
                    ispass = false;
                }
            } else if (fieldname === "OpportunityID") {
                // OpportunityID is optional, but if provided, it must be valid
                if (values.OpportunityID && values.OpportunityID !== "" && values.OpportunityID !== null) {
                    if (opportunityAPIValid === false) {
                        missingFields.push(`${fieldname} (not found in records)`);
                        ispass = false;
                    } else if (!isOpportunityIDValid) {
                        missingFields.push(`${fieldname} (invalid format)`);
                        ispass = false;
                    }
                } else {
                    missingFields.push(`${fieldname}`);
                    ispass = false;
                }
            } else if (fieldname === 'DialogFlowDevToken' || fieldname === 'DialogFlowClientToken') {
                if (values['DialogFlowDevToken'] === "" && values['DialogFlowClientToken'] === "") {
                    missingFields.push('DialogFlow Token (either Dev or Client token required)');
                    ispass = false;
                }
            } else if (fieldname === "TentativeServiceEndDate" && (!selectedEnvironment || selectedEnvironment === "")) {
                // TentativeServiceEndDate requires environment to be selected first
                missingFields.push(fieldname);
                ispass = false;

            } else if (fieldname.indexOf('ADO') >= 0) {
                const toolValue = values.Genwizard_Tool['ADO']

                if (fieldname.replace('ADO_', '') === 'PAT' && toolValue['PAT'] === '') {
                    if (toolValue['Username'] === "" || toolValue['Password'] === "") {
                        missingFields.push(fieldname);
                        ispass = false;
                    }
                } else {
                    if (fieldname.replace('ADO_', '') === 'Username' || fieldname.replace('ADO_', '') === 'Password') {
                        if (toolValue[fieldname.replace('ADO_', '')] === '' && toolValue['PAT'] === '') {
                            ispass = false;
                            missingFields.push(fieldname);
                        }
                    } else {
                        if (toolValue[fieldname.replace('ADO_', '')] === '') {
                            missingFields.push(fieldname);
                            ispass = false;
                        }
                    }
                }
            } else if (fieldname.indexOf('JIRA') >= 0) {
                const toolValue = values.Genwizard_Tool['JIRA']
                if (fieldname.replace('JIRA_', '') === 'PAT' && toolValue['PAT'] === '') {
                    if (toolValue['Username'] === "" || toolValue['Password'] === "") {
                        missingFields.push(fieldname);
                        ispass = false;
                    }
                } else {
                    if (fieldname.replace('JIRA_', '') === 'Password') {
                        if (toolValue[fieldname.replace('JIRA_', '')] === '' && toolValue['PAT'] === '') {
                            ispass = false;
                            missingFields.push(fieldname);
                        }
                    } else {
                        if (toolValue[fieldname.replace('JIRA_', '')] === '') {
                            missingFields.push(fieldname);
                            ispass = false;
                        }
                    }
                }
            } else if (fieldname.indexOf('CONFLUENCE') >= 0) {
                const toolValue = values.Genwizard_Tool['CONFLUENCE']
                if (fieldname.replace('CONFLUENCE_', '') === 'PAT' && toolValue['PAT'] === '') {
                    if (toolValue['Username'] === "" || toolValue['Password'] === "") {
                        missingFields.push(fieldname);
                        ispass = false;
                    }
                } else {
                    if (fieldname.replace('CONFLUENCE_', '') === 'Password') {
                        if (toolValue[fieldname.replace('CONFLUENCE_', '')] === '' && toolValue['PAT'] === '') {
                            ispass = false;
                            missingFields.push(fieldname);
                        }
                    } else {
                        if (toolValue[fieldname.replace('CONFLUENCE_', '')] === '') {
                            missingFields.push(fieldname);
                            ispass = false;
                        }
                    }
                }
            } else if (fieldname.indexOf('FIGMA') >= 0) {
                const toolValue = values.Genwizard_Tool['FIGMA'];
                if (toolValue[fieldname.replace('FIGMA_', '')] === '') {
                    missingFields.push(fieldname);
                    ispass = false;
                }
            } else if (fieldname === "Pocdetails") {
                if (values['Pocdetails'] === "" || !isPocvalid && values['Pocdetails'] !== "") {
                    missingFields.push(fieldname);
                    ispass = false;
                }
            } else if (fieldname === "SecondaryPOC") {
                // For SecondaryPOC, validate as email in full config mode
                if (!values.SecondaryPOC || values.SecondaryPOC === "") {
                    missingFields.push(fieldname);
                    ispass = false;
                } else if (!config && !checkEmailFormat(values.SecondaryPOC)) {
                    // In full config mode, SecondaryPOC should be a valid email (Client Project Requester Email ID)
                    missingFields.push(`${fieldname} (Invalid email format)`);
                    ispass = false;
                }
            } else if (['SMTPUsername', 'SMTPPassword', 'SMTPHostname', 'SMTPPort', 'SMTPSender', 'GCPEndPoint', 'GCPAccessKey', 'S3Bucket', 'S3AccessId', 'S3AccessKey'].includes(fieldname)) {
                if (values.CCAASConfig[fieldname] === "") {
                    missingFields.push(fieldname);
                    ispass = false;
                }
            } else if (['Bedrock Endpoint', 'Bedrock AccessId', 'Bedrock AccessKey', 'Bedrock Arn', 'Bedrock Region', 'Bedrock Model'].includes(fieldname)) {
                if (values.SAPAgentLLMConfig[fieldname.replace('Bedrock ', '')] === "") {
                    missingFields.push(fieldname.replace('Bedrock ', 'BR_'));
                    ispass = false;
                }
            } else if (fieldname === 'BRModelNames') {
                missingFields.push(fieldname);
                ispass = false;
            } else if (values[fieldname] === "" || values[fieldname] === undefined || values[fieldname] === null) {
                missingFields.push(fieldname);
                ispass = false;
            }
        }

        // Use the hook to handle validation results (red borders + dialog)
        handleValidationResult(ispass, missingFields, formClickSubmit);
        return ispass;
    }
    //useEffect

    useEffect(() => {
        const hasAdobeAgentForKM = values.Genwizard_Agent_Module.some(item =>
            adobeAgent.includes(item)
        );

        if ((values.Genwizard_Agent_Module.length === 2 && values.Genwizard_Agent_Module.every(item => ['Config-Agent', 'Contact-Center-Agent'].includes(item)))) {
            let appcore = values.Genwizard_Core.filter(item => item !== 'KM');
            updateGAForm("Genwizard_Core", appcore);
        } else if (hasAdobeAgentForKM) {
            // Adobe agent selected: unlock KM but keep it UNCHECKED — don't auto-add, and remove if present
            let appcore = values.Genwizard_Core.filter(item => item !== 'KM');
            updateGAForm("Genwizard_Core", appcore);
        } else {
            let appcore = values.Genwizard_Core;
            if (values.Genwizard_Core.includes('AD') && !hasAdobeAgentForKM) {
                if (!appcore.includes('KM')) {
                    appcore.push('KM');
                }
            }
            updateGAForm("Genwizard_Core", appcore);
        }

    }, [values.Genwizard_Agent_Module])

    return (
        <>
            <GeneralForm
                isPlanInputValid={isPlanInputValid}
                FormId={0}
                validateInputFields={validateInputFields}
                ClientContractFields={

                    <div>
                        {!config ?
                            <TopRadioWrapper>
                                <ConfigurationFormLabel component="legend">
                                    Is a Contract ID available?
                                </ConfigurationFormLabel>


                                <StyledRadioGroup
                                    aria-label="contract-available"
                                    name="contract-available"
                                    value={isChecked ? "yes" : "no"}
                                    onChange={handleContractAvailabilityChange}
                                    row
                                >
                                    <FormControlLabel
                                        value="yes"
                                        control={<Radio color="primary" />}
                                        label="YES"
                                    />
                                    <FormControlLabel
                                        value="no"
                                        control={<Radio color="primary" />}
                                        label="NO"
                                    />
                                </StyledRadioGroup>
                            </TopRadioWrapper>
                            : ""}

                        {(!isChecked && !config) &&
                            <div style={{ fontSize: "small", color: "#0041F0" }}>
                                <em>
                                    To proceed with provisioning without a Contract ID, please provide the following mandatory details
                                </em>
                                <ul>
                                    <li>WBSE Code (used for chargeback if contract is not provided)</li>
                                    <li>Opportunity ID (for deal tracking and reference)</li>
                                    <li>Expected Contract Availability Date (must be within 42 days)</li>
                                    <li>Client Point of Contact (name and email for contract follow-up)</li>
                                </ul>
                            </div>
                        }
                        <div style={{ flexGrow: 1 }}>
                            <Grid
                                container
                                spacing={2}
                            >
                                {(!config && isChecked) ?
                                    <Grid item xs={4}>
                                        {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                                    </Grid>
                                    : (!config && !isChecked) ?
                                        <Grid item xs={4}>
                                            {FormField.Pocvalid(handleChange, values, isPocvalid)}
                                        </Grid>
                                        : <></>
                                }

                                {(!config &&
                                    isChecked &&
                                    sapContractCodeLength === 10 &&
                                    !isExternalClientLoading &&
                                    !externalClientError) &&
                                    <Grid item xs={4}>
                                        {PlatformFormField.ClientNamePlatformField(
                                            values,
                                            handleChange,
                                            externalClientData[0]
                                        )}
                                    </Grid>
                                }
                                {!config &&
                                    isChecked &&
                                    sapContractCodeLength === 10 &&
                                    !isExternalClientLoading &&
                                    !externalClientError && (
                                        <Grid item xs={4}>
                                            {PlatformFormField.EndToEndUIdPlatformField(
                                                values,
                                                handleChange,
                                                externalClientData[1]
                                            )}
                                        </Grid>
                                    )
                                }
                                {(!config && !isChecked) &&
                                    <Grid item xs={4}>
                                        <StyledTooltip
                                            title={longTextEndDate}
                                            placement="left-start"
                                            noValidate
                                        >
                                            <DateTextFieldCommonComponentv2
                                                tentativeServiceEndDate={values.ContractAvailabilityDate}
                                                minDate={0}
                                                maxDate={createMaxDate(27)}
                                                handleChange={handleChange}
                                                idkey="ContractAvailabilityDate"
                                                label="Contract Availability Date"
                                            />
                                        </StyledTooltip>
                                    </Grid>
                                }
                                {(!config) &&
                                    <>
                                        <Grid item xs={4}>
                                            <RITMField
                                                handleChange={handleChange}
                                                values={values}
                                                isRITMValid={isRITMValid}
                                                onApiValidationChange={setRitmAPIValid}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <OpportunityIDField
                                                handleChange={handleChange}
                                                values={values}
                                                isOpportunityIDValid={isOpportunityIDValid}
                                                onApiValidationChange={setOpportunityAPIValid}
                                            />
                                        </Grid>
                                    </>
                                }
                                {(!config && !isChecked) &&
                                    <Grid item xs={4}>
                                        {FormField.ClientNamePlatformInternal(handleChange, values)}
                                    </Grid>}
                                <Grid item xs={4}>
                                    {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                                </Grid>

                                {/* <Grid item xs={4}>
                                    {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSEValid, isLoading)}
                                </Grid > */}
                                {config &&
                                    <Grid item xs={4}>
                                        <RITMField
                                            handleChange={handleChange}
                                            values={values}
                                            isRITMValid={isRITMValid}
                                            onApiValidationChange={setRitmAPIValid}
                                        />
                                    </Grid>
                                }
                                <Grid item xs={4}>
                                    {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSEValid, isLoading)}
                                </Grid >
                                <Grid item xs={4}>
                                    {FormField.SecondaryContact(handleChange, values, config)}
                                </Grid>
                                <Grid item xs={4}>
                                    {FormField.DataClassificationField(handleChange, values, configurationType)}
                                </Grid>
                                {!config && (
                                    <Grid item xs={4}>
                                        {FormField.DeploymentPhaseField(handleChange, values, env)}
                                    </Grid>
                                )}
                                <Grid item xs={4}>
                                    {FormField.TeamNamesField(handleChange, values, isTeamNameSelected, 'na', configurationType, instanceType)}
                                </Grid >
                                {values.TeamName === "Others" &&
                                    <Grid item xs={4}>
                                        {FormField.TeamNameOthers(handleChange, values)}
                                    </Grid >
                                }
                                {
                                    (config &&
                                        <Grid item xs={4}>
                                            {FormField.ClientNamePlatformInternal(handleChange, values)}
                                        </Grid>
                                    )
                                }
                                {/* <Grid item xs={4}>
                {config &&
                  FormField.ClientNamePlatformInternal(handleChange, values)}
              </Grid > */}
                                <Grid item xs={12}>
                                    {PlatformFormField.RequestNotesPlatformField(
                                        values,
                                        handleChange,
                                        notesValidations
                                    )}
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                }
                EnvironmentFields={
                    <div>
                        <div style={{ flexGrow: 1 }}>
                            <Grid
                                container
                                spacing={2}
                            >
                                <Grid item xs={12}>
                                    {PlatformFormField.GDPRPlatformField(
                                        values,
                                        handleChange,
                                        isGDPR,
                                        classes,
                                        config,
                                        isChecked,
                                        externalClientData
                                    )}
                                </Grid>
                                <Grid item xs={3}>
                                    {PlatformFormField.agent_deploymentRegion(
                                        values,
                                        handleChange,
                                        isGDPR,
                                        isDedicated,
                                        isOpenAI,
                                        instanceType,
                                        values.TeamName,
                                        configurationType
                                    )}
                                </Grid>
                                <Grid item xs={6}>
                                    {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                                        values,
                                        handleChangeRootSuggestions,
                                        // handleChangeRoot,
                                        isRootExist,
                                        rootExistedHint,
                                        rootWrongFormatHint,
                                        externalClientData,
                                        domainContextRoot,
                                        isLoading
                                    ) : PlatformFormField.DomainContextRootPlatformField(
                                        values,
                                        handleChangeRoot,
                                        isRootExist,
                                        rootExistedHint,
                                        isLoading
                                    )}
                                </Grid>
                                <Grid item xs={3}>
                                    {values.DataClassification === "Client-NonProduction"
                                        ? PlatformFormField.EnvironmentClientNonProdField(values, handleChange)
                                        : PlatformFormField.EnvironmentField(values, handleChange, env)}
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                }

                ApplicationFields={
                    <div style={{ flexGrow: 1 }}>
                        <Grid
                            container
                            spacing={2}
                        >
                            {/* <Grid item xs={4}>
                                {FormField.DialogFlowField(handleChange, values, isDialogFlow)}
                            </Grid> */}
                            <Grid item xs={6}>
                                {FormField.ChatGPTFieldGA(handleChange, values)}
                            </Grid>
                            <Grid item xs={6}>
                                {FormField.OpenAITextEmbeddingsModel(handleChange, values)}
                            </Grid>
                            {/* if user select enable in DialogFlow, it would show DialogFlowDevToken with default value */}
                            {isDialogFlow &&
                                <Grid item xs={6}>{FormField.DialogFlowDevTokenField(handleChange, values)}</Grid>}
                            {isDialogFlow &&
                                <Grid item xs={6}>{FormField.DialogFlowClientTokenField(handleChange, values)}</Grid>}
                            {/* <Grid item xs={6}>
                                {FormField.SuperAdminDistributionGroupFieldQpp(handleChange, values, errorSADGroup, isADSADUnique)}
                            </Grid> */}
                            <Grid item xs={6}>
                                {/* {FormField.AdminDistributionGroupFieldQpp(handleChange, values, errorADGroup, isADSADUnique)} */}
                                {FormField.AdminDistributionGroupField(handleChange, values)}
                            </Grid>
                            <Grid item xs={6}>
                                <StyledTooltip
                                    title={longTextEndDate}
                                    placement="left-start"
                                    noValidate
                                >
                                    <DateTextFieldCommonComponent
                                        tentativeServiceEndDate={values.TentativeServiceEndDate}
                                        selectedEnvironment={selectedEnvironment}
                                        isServiceEndDateInvalid={isServiceEndDateInvalid}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        handleChange={handleChange}
                                        style={{ paddingTop: "10px" }}
                                    />
                                </StyledTooltip>
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ fontSize: "1rem", color: '#5f47c9', fontWeight: '600' }}>
                                    <label>
                                        Core
                                    </label>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                {values.Genwizard_Core.includes("CUI") &&
                                    <p>CUI URL: <span style={{ color: " #0041F0" }}>https://cui-{domainContextRoot}.genwizardai.com/</span></p>
                                }
                                {/* {values.Genwizard_Core.includes("IAM") &&
                                    <p>IM URL: <span style={{ color: " #0041F0" }}>&nbsp;https://iam-{domainContextRoot}.genwizardai.com/</span></p>
                                } */}
                                {values.Genwizard_Core.includes("KM") &&
                                    <p>KM URL: <span style={{ color: " #0041F0" }}>https://qpp-{domainContextRoot}.genwizardai.com/</span></p>
                                }
                                {values.Genwizard_Core.includes("AM") &&
                                    <p>Expected Custom AM UI URL: <span style={{ color: " #0041F0" }}>https://{domainContextRoot}.agentsmgr.com/</span></p>
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ fontSize: "small", color: "#c20000" }}>
                                    <em>
                                        Please select at least one App Core. Some App Core components require others to be installed. CUI and IM are bundles.
                                    </em>
                                </div>
                            </Grid>
                            <Grid item xs={6} id="Genwizard_Core_wrapper">
                                <FormGroup style={{ marginTop: '7px', padding: '0px 5px' }}>
                                    <FormControlLabel
                                        style={{ width: '300px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={values.Genwizard_Core.includes('CUI')}
                                                onChange={(e) => handleChange(e, "Genwizard_Core")}
                                                name="CUI"
                                            />
                                        }
                                        label={
                                            <>
                                                Conversational UI (CUI)
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>{coreVersion['cui']}</em>
                                            </>
                                        }
                                    />
                                    <FormControlLabel
                                        style={{ width: '300px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={values.Genwizard_Core.includes('KM')}
                                                disabled={
                                                    !(
                                                        values.Genwizard_Core.includes("CUI") ||
                                                        values.Genwizard_Core.includes("UTKM") ||
                                                        (values.Genwizard_Agent_Module.length === 2 && values.Genwizard_Agent_Module.every(item => ['Config-Agent', 'Contact-Center-Agent'].includes(item))) ||
                                                        (
                                                            values.Genwizard_Core.includes("AD") &&
                                                            values.Genwizard_Agent_Module.some(item =>
                                                                adobeAgent.includes(item)
                                                            )
                                                        )
                                                    )
                                                }
                                                onChange={(e) => handleChange(e, "Genwizard_Core")}
                                                name="KM"
                                            />
                                        }
                                        label={
                                            <>
                                                Knowledge Manager (KM)
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>{coreVersion['km']}</em>
                                            </>
                                        }

                                    />
                                    {(!config && !externalClientError) &&
                                        <FormControlLabel
                                            style={{ width: '300px', position: 'relative' }}
                                            control={
                                                <Checkbox
                                                    checked={values.Genwizard_Core.includes('AM')}
                                                    onChange={(e) => handleChange(e, "Genwizard_Core")}
                                                    name="AM"
                                                    disabled={(!config && !externalClientError) ? false : true}
                                                />
                                            }

                                            label={
                                                <>
                                                    Agent Manager (AM)
                                                    <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>{coreVersion['am']}</em>
                                                </>
                                            }
                                        />
                                    }
                                    <FormControlLabel
                                        style={{ width: '300px', position: 'relative' }}
                                        control={
                                            <Checkbox
                                                checked={values.Genwizard_Agent_Module.includes('Config-Agent')}
                                                onChange={(e) => { handleChange(e, "Genwizard_Agent_Module") }}
                                                name="Config-Agent"
                                                disabled={true}
                                            />
                                        }
                                        label={
                                            <>
                                                Config Agent
                                                <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>{coreVersion['ca']}</em>
                                            </>
                                        }
                                    />
                                </FormGroup>
                            </Grid>
                            {/* {values.Genwizard_Core.includes("AM") &&
                                <>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: "1rem", color: '#5f47c9', fontWeight: '600' }}>
                                            <label>
                                                AM Bedrock Model
                                            </label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <em style={{ fontSize: ".8em", color: '#c20000' }}>
                                            Note: Automated configuration of Bedrock on the AM instance has not yet been implemented; manual configuration is required.
                                        </em>
                                    </Grid>
                                    <Grid item xs={4} id="Genwizard_agent_wrapper">
                                        {FormField.BedrockPlatformModel(values, handleChange, '')}
                                    </Grid>
                                </>
                            } */}
                            <Grid item xs={12}>
                                <div style={{ fontSize: "1rem", color: '#5f47c9', fontWeight: '600' }}>
                                    <label>
                                        Agent
                                    </label>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    style={{ width: '300px', position: 'relative' }}
                                    control={
                                        <Checkbox
                                            checked={values.Genwizard_Core.includes('UTKM')}
                                            onChange={(e) => handleChange(e, "Genwizard_Core")}
                                            name="UTKM" />
                                    }
                                    label={
                                        <>
                                            Steward
                                            <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>{coreVersion['stw']}</em>
                                        </>
                                    }
                                />
                            </Grid>
                            {values.Genwizard_Core.includes("UTKM") &&
                                <>
                                    <Grid item xs={12}>
                                        <p>Knowledge Transition URL: <span style={{ color: " #0041F0" }}>https://cui-{domainContextRoot}.genwizardai.com/knowledgetransition</span></p>
                                        <p>Steward URL: <span style={{ color: " #0041F0" }}>https://cui-{domainContextRoot}.genwizardai.com</span></p>
                                    </Grid>
                                    {/* <Grid item xs={12}>
                                        <div style={{ fontSize: "small", color: "#c20000" }}>
                                            <em>
                                                Selecting KT + IM, CUI and KM are optional and KT + Agent required the core apps CUI, KM and Config Agent.
                                            </em>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>
                                        {FormField.GASteward(handleChange, values)}
                                    </Grid> */}
                                </>
                            }
                            <Grid item xs={12}>
                                <FormControlLabel
                                    style={{ width: '300px', position: 'relative' }}
                                    control={
                                        <Checkbox
                                            checked={values.Genwizard_Core.includes('AD')}
                                            onChange={(e) => handleChange(e, "Genwizard_Core")}
                                            name="AD" />
                                    }
                                    label={
                                        <>
                                            AD
                                            <em style={{ marginTop: '1px', fontSize: '.85rem', color: '#8802ee', position: 'absolute', right: '10px' }}>{coreVersion['ad']}</em>
                                        </>
                                    }
                                />
                            </Grid>
                            {values.Genwizard_Core.includes("AD") &&
                                <>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: "small", color: "#c20000" }}>
                                            <em>
                                                Selecting AD requires CUI, and KM. To choose a different app, uncheck AD.
                                            </em>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <p>AD UI URL:<span style={{ color: " #0041F0" }}>https://cui-{domainContextRoot}.genwizardai.com/</span></p>
                                        <p>AD API URL: <span style={{ color: " #0041F0" }}>https://ad-api-{domainContextRoot}.genwizardai.com/</span></p>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: "small", color: "#c20000" }}>
                                            <em>
                                                Select AD Agent
                                            </em>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4} id="Genwizard_agent_wrapper">
                                        {FormField.GAAgents(handleChange, values, disabledAgents)}
                                    </Grid>
                                </>
                            }
                            {
                                sapAgent.some(term => values.Genwizard_Agent_Module.includes(term)) &&
                                <>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: "1rem", color: '#5f47c9', fontWeight: '600' }}>
                                            <label>
                                                SAP Agent Configuration
                                            </label>
                                        </div>
                                    </Grid>
                                    {/* <Grid item xs={6}>
                                        <div style={{ fontSize: "small", color: "#c20000" }}>
                                            <em>
                                                Select LLM Provider
                                            </em>
                                        </div>
                                    </Grid> */}
                                    <Grid item xs={12}>
                                        {FormField.SAPAgentLLM(handleChange, values)}
                                    </Grid>
                                    {values.SAPAgentLLM === "AZURE" ?
                                        <Grid item xs={4}>
                                            {FormField.sapAgentClaude(handleChange, values)}
                                        </Grid>
                                        :
                                        <>
                                            <Grid item xs={4}>
                                                {FormField.BedrockEndpoint(handleChange, values)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.BedrockArn(handleChange, values, ttpword, setTtpword)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.BedrockRegion(handleChange, values)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.BedrockAccessId(handleChange, values)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.BedrockAccessKey(handleChange, values, ttpword, setTtpword)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.BedrockModel(handleChange, values)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.TextField(handleChange, values.SAPAgentLLMConfig['DeploymentModelId'], "Bedrock Deployment Id", true)}
                                            </Grid>
                                        </>
                                    }
                                </>
                            }
                            {values.Genwizard_Agent_Module.includes('Contact-Center-Agent') &&
                                <>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: "1rem", color: '#5f47c9', fontWeight: '600' }}>
                                            <label>
                                                CCAAS Configuration
                                            </label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: ".8rem", color: '#c20000' }}>
                                            <label>
                                                Note : For security enhancement key/password be will encrypted after submitting
                                            </label>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <div style={{ fontSize: ".8rem", color: '#5f47c9' }}>
                                            <label>
                                                GCP Configuration
                                            </label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>
                                        {FormField.GAGCPEndPoint(handleChange, values)}
                                    </Grid>
                                    <Grid item xs={4}>
                                        {FormField.GAGCPAccessKey(handleChange, values, ttpword, setTtpword)}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: ".8rem", color: '#5f47c9' }}>
                                            <label>
                                                S3 Configuration
                                            </label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: ".8rem", color: '#c20000' }}>
                                            <label>
                                                Note : By default S3 Bucket Configuration is set to <strong>No</strong>, S3 Bucket will be create
                                            </label>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        {FormField.useExistingS3Bucket(handleChange, values)}
                                    </Grid>
                                    {values.UseS3Bucket === "Yes" &&
                                        <>
                                            <Grid item xs={4}>
                                                {FormField.GAS3Bucket(handleChange, values)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.GAS3AccessId(handleChange, values)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.GAS3AccessKey(handleChange, values, ttpword, setTtpword)}
                                            </Grid>
                                        </>
                                    }
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: ".8rem", color: '#5f47c9' }}>
                                            <label>
                                                Macros Configuration
                                            </label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: ".8rem", color: '#c20000' }}>
                                            <label>
                                                Note : By default SMTP Configuration is set to <strong>No</strong>, SMTP config will be create
                                            </label>
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        {FormField.useExistingSMTPIntegration(handleChange, values)}
                                    </Grid>
                                    {values.UseSMTPConfig === "Yes" &&
                                        <>
                                            <Grid item xs={4}>
                                                {FormField.GASMTPHostName(handleChange, values)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.GASMTPPort(handleChange, values)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.GASMTPSender(handleChange, values)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.GASMTPUsername(handleChange, values)}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {FormField.GASMTPPassword(handleChange, values, ttpword, setTtpword)}
                                            </Grid>
                                        </>
                                    }
                                </>
                            }
                            {values.Genwizard_Core.includes('AD') &&
                                <>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: "1rem", color: '#5f47c9', fontWeight: '600' }}>
                                            <label>
                                                AD Tool
                                            </label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: ".8rem", color: "#5f47c9" }}>
                                            <em>
                                                This features only available on for AD Agent
                                            </em>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ fontSize: ".8rem", color: '#c20000' }}>
                                            <label>
                                                Note : For security enhancement key/password will be encrypted after submitting
                                            </label>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormGroup style={{ padding: '0px 5px' }}>
                                            <FormControlLabel
                                                style={{ width: '600px', position: 'relative', margin: '0 0 0 -20px' }}
                                                control={
                                                    <Checkbox
                                                        checked={values.Genwizard_Agent_Tool.includes('ADO')}
                                                        onChange={(e) => handleChange(e, "Genwizard_Agent_Tool")}
                                                        name="ADO"
                                                    />
                                                }
                                                label="ADO"
                                            />
                                        </FormGroup>
                                    </Grid>
                                    {values.Genwizard_Agent_Tool.includes('ADO') &&
                                        <>
                                            <Grid item xs={12}>
                                                <FormGroup style={{ margin: '0' }}>
                                                    <FormControlLabel
                                                        style={{ width: '300px', position: 'relative', margin: '0 0 -25px -5px' }}
                                                        control={
                                                            <Checkbox
                                                                checked={usePAT['ADO']}
                                                                onChange={(e) => {
                                                                    setUsePAT({ ...usePAT, 'ADO': !usePAT['ADO'] })
                                                                    clearPATandPassword('ADO')
                                                                }}
                                                                name="PAT"
                                                                size="small"
                                                            />
                                                        }
                                                        label={<em style={{ fontSize: '.8rem', color: '#A20000' }}>Use Personal Token</em>}
                                                    />
                                                </FormGroup>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolProjectKey(handleChange, values, "ADO")}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolEndPoint(handleChange, values, "ADO")}
                                            </Grid>
                                            {!usePAT['ADO'] ?
                                                <>
                                                    <Grid item xs={3}>
                                                        {FormField.GAToolUsername(handleChange, values, "ADO")}
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        {FormField.GAToolPassword(handleChange, values, "ADO", ttpword, setTtpword)}
                                                    </Grid>
                                                </>
                                                :
                                                <Grid item xs={3}>
                                                    {FormField.GAToolPAT(handleChange, values, "ADO")}
                                                </Grid>
                                            }
                                        </>
                                    }
                                    <Grid item xs={12}>
                                        <FormGroup style={{ padding: '0px 5px' }}>
                                            <FormControlLabel
                                                style={{ width: '300px', position: 'relative', margin: '0 0 0 -20px' }}
                                                control={
                                                    <Checkbox
                                                        checked={values.Genwizard_Agent_Tool.includes('JIRA')}
                                                        onChange={(e) => handleChange(e, "Genwizard_Agent_Tool")}
                                                        name="JIRA" />
                                                }
                                                label="JIRA"
                                            />
                                        </FormGroup>
                                    </Grid>
                                    {values.Genwizard_Agent_Tool.includes('JIRA') &&
                                        <>
                                            <Grid item xs={12}>
                                                <FormGroup style={{ margin: '0' }}>
                                                    <FormControlLabel
                                                        style={{ width: '300px', position: 'relative', margin: '0 0 -25px -5px' }}
                                                        control={
                                                            <Checkbox
                                                                checked={usePAT['JIRA']}
                                                                onChange={(e) => {
                                                                    setUsePAT({ ...usePAT, 'JIRA': !usePAT['JIRA'] })
                                                                    clearPATandPassword('JIRA');
                                                                }}
                                                                name="PAT"
                                                                size="small"
                                                            />
                                                        }
                                                        label={<em style={{ fontSize: '.8rem', color: '#A20000' }}>Use Personal Token</em>}
                                                    />
                                                </FormGroup>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolProjectKey(handleChange, values, "JIRA")}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolEndPoint(handleChange, values, "JIRA")}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolUsername(handleChange, values, "JIRA")}
                                            </Grid>
                                            {!usePAT['JIRA'] ?
                                                <Grid item xs={3}>
                                                    {FormField.GAToolPassword(handleChange, values, "JIRA", ttpword, setTtpword)}
                                                </Grid>
                                                :
                                                <Grid item xs={3}>
                                                    {FormField.GAToolPAT(handleChange, values, "JIRA")}
                                                </Grid>
                                            }
                                        </>
                                    }
                                    <Grid item xs={12}>
                                        <FormGroup style={{ padding: '0px 5px' }}>
                                            <FormControlLabel
                                                style={{ width: '300px', position: 'relative', margin: '0 0 0 -20px' }}
                                                control={
                                                    <Checkbox
                                                        checked={values.Genwizard_Agent_Tool.includes('CONFLUENCE')}
                                                        onChange={(e) => handleChange(e, "Genwizard_Agent_Tool")}
                                                        name="CONFLUENCE" />
                                                }
                                                label="CONFLUENCE"
                                            />
                                        </FormGroup>
                                    </Grid>
                                    {values.Genwizard_Agent_Tool.includes('CONFLUENCE') &&
                                        <>
                                            <Grid item xs={12}>
                                                <FormGroup style={{ margin: '0' }}>
                                                    <FormControlLabel
                                                        style={{ width: '300px', position: 'relative', margin: '0 0 -25px -5px' }}
                                                        control={
                                                            <Checkbox
                                                                checked={usePAT['CONFLUENCE']}
                                                                onChange={(e) => {
                                                                    setUsePAT({ ...usePAT, 'CONFLUENCE': !usePAT['CONFLUENCE'] })
                                                                    clearPATandPassword('CONFLUENCE')
                                                                }}
                                                                name="PAT"
                                                                size="small"
                                                            />
                                                        }
                                                        label={<em style={{ fontSize: '.8rem', color: '#A20000' }}>Use Personal Token</em>}
                                                    />
                                                </FormGroup>
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolProjectKey(handleChange, values, "CONFLUENCE")}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolEndPoint(handleChange, values, "CONFLUENCE")}
                                            </Grid>

                                            <Grid item xs={3}>
                                                {FormField.GAToolUsername(handleChange, values, "CONFLUENCE")}
                                            </Grid>
                                            {!usePAT['CONFLUENCE'] ?
                                                <Grid item xs={3}>
                                                    {FormField.GAToolPassword(handleChange, values, "CONFLUENCE", ttpword, setTtpword)}
                                                </Grid>
                                                :
                                                <Grid item xs={3}>
                                                    {FormField.GAToolPAT(handleChange, values, "CONFLUENCE")}
                                                </Grid>
                                            }
                                        </>
                                    }
                                    <Grid item xs={12}>
                                        <FormGroup style={{ padding: '0px 5px' }}>
                                            <FormControlLabel
                                                style={{ width: '300px', position: 'relative', margin: '0 0 0 -20px' }}
                                                control={
                                                    <Checkbox
                                                        checked={values.Genwizard_Agent_Tool.includes('FIGMA')}
                                                        onChange={(e) => handleChange(e, "Genwizard_Agent_Tool")}
                                                        name="FIGMA" />
                                                }
                                                label="FIGMA"
                                            />
                                        </FormGroup>
                                    </Grid>
                                    {values.Genwizard_Agent_Tool.includes('FIGMA') &&
                                        <>
                                            <Grid item xs={3}>
                                                {FormField.GAToolEndPoint(handleChange, values, "FIGMA")}
                                            </Grid>
                                            <Grid item xs={3}>
                                                {FormField.GAToolPAT(handleChange, values, "FIGMA")}
                                            </Grid>
                                        </>
                                    }
                                </>
                            }
                        </Grid>
                    </div >
                }
                LeftColumnFields={
                    <div>
                    </div>
                }
                RightColumnFields={
                    <div>
                    </div>
                }
                history={history}
                productname={'GenwizardAgent'}
                gaversion={history.location.state.GAVersion}
            ></GeneralForm>

            {/* Validation Error Dialog */}
            <ValidationDialog
                open={showValidationDialog}
                onClose={closeDialog}
                errors={validationErrors}
            />

            {!isChecked && (
                <CommonDialogV2
                    open={isNoteVisible}
                    onClose={() => setNoteVisible(false)}
                    title={"Note"}
                    textContent={
                        <div>
                            <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
                            <ul>
                                <li>
                                    Provisioned services will be automatically stopped
                                </li>
                                <li>
                                    Cost recovery will be initiated using the provided WBSE code
                                </li>
                            </ul>
                        </div>
                    }
                    dialogActions={
                        <DialogActions >
                            <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
                        </DialogActions>
                    }
                ></CommonDialogV2>
            )}
        </>
    );
};

const MSTP = (state, ownProps) => ({
    values: state.fui.GAForm,
    isRootExist: state.fui.isRootExist,
    isWBSEValid: state.fui.isWBSEValid,
    configurationType: state.fui.configurationType,
    email: state.auth.userDetails.email,
    idToken: state.auth.idToken,
    externalClientData: state.fui.externalClientData,
    externalClientError: state.fui.externalClientError,
    isExternalClientLoading: state.fui.isExternalClientLoading,
    isLoading: state.fui.isLoading,
});

export default connect(MSTP, {
    checkDomainAvaliable: checkRootExisted,
    updateGAForm: fuiRedux.updateGAForm,
    fetchExternalClientDetails,
    checkIsWBSEValid
})(withRouter(GenWizardAgent));
